import { useCallback } from 'react';
import { useDynamicModal } from 'components/DynamicModalProvider/useDynamicModal';
import { CreateSandboxModal } from 'SandboxModule/components/CreateSandboxModal';

const useCreateSandboxModal = () => {
  const { openModal } = useDynamicModal();

  const openCreateSandboxModal = useCallback(() => {
    openModal({
      modal: ({ isOpen: _isOpen, toggle }) => {
        return <CreateSandboxModal toggle={toggle} />;
      },
    });
  }, [openModal]);

  return {
    openCreateSandboxModal,
  };
};

export default useCreateSandboxModal;
